// extracted by mini-css-extract-plugin
export var addDetails = "_2-l";
export var addEditButton = "_2-b";
export var addressFields = "_2-2";
export var animationContainer = "_2-0";
export var closeButton = "_2-p";
export var customerDetails = "_2-x";
export var customerInformationWrapper = "_2-6";
export var dropdowns = "_2-4";
export var error = "_2-k";
export var fields = "_2-n";
export var flex = "_2-m";
export var grow = "_2-3";
export var icon = "_2-d";
export var imageButton = "_2-q";
export var imagesWrapper = "_2-s";
export var itemDetails = "_2-i";
export var itemSelectionHeader = "_2-9";
export var label = "_2-w";
export var lineItemImage = "_2-j";
export var lineItemReturnedWrapper = "_2-h";
export var lineItemWrapper = "_2-g";
export var modalContent = "_2-f";
export var modalFooter = "_2-1";
export var multipleChoiceAnswer = "_2-u";
export var multipleChoiceAnswersWrapper = "_2-t";
export var orderButton = "_2-z";
export var orderLabel = "_2-10";
export var orderSelection = "_2-y";
export var question = "_2-v";
export var search = "_2-e";
export var selectCheckbox = "_2-a";
export var selectionWrapper = "_2-8";
export var spinner = "_2-c";
export var subheader = "_2-5";
export var title = "_2-7";
export var uploadedImage = "_2-o";
export var uploadedImageWrapper = "_2-r";